const API = process.env.REACT_APP_BACKEND_URL;

export function adminFetch(pathOrUrl, options = {}) {
  const url = String(pathOrUrl).startsWith("http") ? pathOrUrl : `${API}${pathOrUrl}`;
  return fetch(url, { ...options, credentials: "include" }).then((response) => {
    if (response.status === 401 && window.location.pathname !== "/admin/login") {
      const returnTo = `${window.location.pathname}${window.location.search}`;
      window.location.assign(`/admin/login?returnTo=${encodeURIComponent(returnTo)}`);
    }
    return response;
  });
}

export { API as ADMIN_API_BASE };
